import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../AppContext";
import {
  CartItem,
  Routing,
  ProductTypes,
  Device,
  CardMachine,
  Product,
} from "../../file.interface";
import { formatAsEuro } from "../../helpers/helpers";
import "../../components/dynamic-table/dynamic-table.css";
//import { ScreenContainer } from "../../components/containers";
//
const SitesScreen3: React.FC = () => {
  const navigate = useNavigate();
  const {
    selectedContractDuration,
    selectedIndustry,
    sites,
    dispatch,
    selectedPOSSolution,
    routing,
  } = useAppContext();

  useEffect(() => {
    //Bronze plan should have 1 device only, change to silver if it has more.
    /*     if (
      selectedPOSSolution?.POSSolutionName === POSSolutions[4].POSSolutionName
    ) {
      let devicesCounter = 0;
      sites.forEach((site) => {
        devicesCounter += site.cart.length;
      });

      if (devicesCounter > 1)
        dispatch({
          type: "UPDATE_CONTEXT",
          payload: {
            selectedPOSSolution: POSSolutions[5],
          },
        });
    } */
    console.log("Delete flows");
    dispatch({
      type: "UPDATE_CONTEXT",
      payload: {
        flowDevices: [],
        flowCardMachines: [],
        flowAccessories: [],
      },
    });
  }, []);

  const handleSiteFlow = (siteIndex: number | null) => {
    if (siteIndex !== null) {
      // SET PROVITIONAL FLOWS
      let flowDevices = sites[siteIndex].cart.filter(
        (item): item is Device => item.type === ProductTypes.Epos
      );
      let flowCardMachines = sites[siteIndex].cart.filter(
        (item): item is CardMachine => item.type === ProductTypes.Terminals
      );
      let flowAccessories = sites[siteIndex].cart.filter(
        (item): item is Product => item.type === ProductTypes.Accesories
      );

      dispatch({
        type: "UPDATE_CONTEXT",
        payload: {
          selectedSiteFlow: siteIndex,
          isNewSite: false,
          flowDevices,
          flowAccessories,
          flowCardMachines,
        },
      });
    } else {
      dispatch({
        type: "UPDATE_CONTEXT",
        payload: {
          selectedSiteFlow: sites.length,
          isNewSite: true,
        },
      });
    }

    if (routing === Routing.Terminals) {
      navigate("/terminals-screen-2");
    } else {
      navigate("/devices-screen-1");
    }
  };

  const removeSiteFlow = (siteIndex: number) => {
    let _site = [...sites];
    _site.splice(siteIndex, 1);
    dispatch({
      type: "UPDATE_CONTEXT",
      payload: {
        sites: _site.map((item, i) => {
          return {
            ...item,
            name: `SITE # ${i + 1}`,
          };
        }),
      },
    });
  };
  const getSitesTotal = () => {
    if (sites.length > 0) {
      let total: number = 0;
      for (let index = 0; index < sites.length; index++) {
        total += sites[index].cart.reduce(
          (total, item) =>
            total +
            item.prices[selectedContractDuration] +
            ("cardMachine" in item && item.cardMachine
              ? item.cardMachine?.prices[selectedContractDuration]
              : 0) +
            ("licenceFee" in item && item.licenceFee ? item.licenceFee : 0),
          0
        );
      }
      return (
        <div style={{ fontWeight: "bold" }}>
          Grand Total for Sites: {formatAsEuro(total)}
        </div>
      );
    }
  };

  return (
    <div className="screen-container">
      {selectedIndustry && selectedContractDuration && (
        <>
          <img
            src={selectedPOSSolution?.POSSolutionLogo}
            alt=""
            className="pos-solution-logo"
          />
          {/*           <h4
            className="subtitle-screen"
            style={{ maxWidth: 500, textAlign: "center" }}
          >
            {selectedPOSSolution?.POSSolutionName}
          </h4> */}
        </>
      )}
      {sites.length === 0 && (
        <>
          <h3 className="title-screen">Create your site</h3>
          <h4
            className="subtitle-screen"
            style={{ maxWidth: 500, textAlign: "center" }}
          >
            A “site” is your business’s location where you need your EPOS
            system. If you have different branches, you’ll have more than one
            site.
          </h4>
        </>
      )}

      {sites && (
        <>
          {sites.map((site, i) => {
            return (
              <div className="product-table-main-container" key={i}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    margin: "20px 20px",
                  }}
                >
                  <div style={{ fontWeight: "bold", fontSize: 21 }}>
                    {site.name}
                  </div>
                  <div style={{ display: "flex", gap: 30 }}>
                    <div
                      className="icon-button"
                      onClick={() => handleSiteFlow(i)}
                    >
                      <img
                        src="https://npi.ie/wp-content/uploads/2023/12/edit-50.svg"
                        alt=""
                      />
                    </div>
                    <div
                      className="icon-button"
                      onClick={() => removeSiteFlow(i)}
                    >
                      <img
                        src="https://npi.ie/wp-content/uploads/2023/12/remove-21.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>

                {site?.cart.map((product: CartItem, j) => {
                  let devicePrice: string | number =
                    product.prices[selectedContractDuration];
                  let deviceTitle: string = product.name;

                  if ("cardMachine" in product && product.cardMachine) {
                    devicePrice +=
                      product.cardMachine.prices[selectedContractDuration];
                    deviceTitle = `${deviceTitle} + ${product.cardMachine.name}`;
                  }
                  if ("licenceFee" in product && product.licenceFee > 0) {
                    devicePrice += product.licenceFee;
                    deviceTitle += " + Licence";
                  }

                  devicePrice = formatAsEuro(devicePrice);

                  return (
                    <div key={product.type + j + i}>
                      <div className="product-row-container">
                        <div className="product-row-img">
                          <img src={product.imageUrl} alt="" />
                        </div>
                        <div className="product-row-name-2">{deviceTitle}</div>
                        <div className="product-row-price">{devicePrice}</div>
                      </div>
                      {j !== site.cart.length - 1 && (
                        <>
                          <div className="app-separator" />
                        </>
                      )}
                    </div>
                  );
                })}
                <>
                  <div className="app-separator" />
                  <div className="total-align-right">
                    Total:{" "}
                    {formatAsEuro(
                      site.cart.reduce(
                        (total, item) =>
                          total +
                          item.prices[selectedContractDuration] +
                          ("cardMachine" in item && item.cardMachine
                            ? item.cardMachine?.prices[selectedContractDuration]
                            : 0) +
                          ("licenceFee" in item && item.licenceFee
                            ? item.licenceFee
                            : 0),
                        0
                      )
                    )}{" "}
                    monthly
                  </div>
                </>
              </div>
            );
          })}
        </>
      )}

      {getSitesTotal()}

      <button
        className="app-button new-site-button"
        onClick={() => handleSiteFlow(null)}
      >
        {sites.length > 0 ? "Add Another Site" : "Set Up a Site"}
      </button>

      <div className="buttons-container">
        <button
          className="app-button previous-button"
          onClick={() => navigate(-1)}
        >
          Previous
        </button>

        {sites.length > 0 && (
          <button
            className="app-button next-button"
            onClick={() => navigate("/delivery-screen-4")}
          >
            Continue with delivery
          </button>
        )}
      </div>
    </div>
  );
};

export default SitesScreen3;
